import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import { Supplier } from '../models/supplier';

export class SupplierApi {
    constructor(protected baseUrl: string) {}

    public cget(
        params: URLSearchParams = new URLSearchParams(),
        abortSignal?: AbortSignal
    ): Promise<ApiResult<PaginatedResponse<Supplier>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/suppliers`, { params, signal: abortSignal }),
            response => {
                response.data.items = response.data.items.map(Supplier.fromPlainObject);
                return response.data;
            }
        );
    }
    public cgetImportSuppliers(
        params: URLSearchParams = new URLSearchParams(),
        abortSignal?: AbortSignal
    ): Promise<ApiResult<PaginatedResponse<Supplier>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/import-suppliers/available-suppliers`, { params, signal: abortSignal }),
            response => {
                response.data.items = response.data.items.map(Supplier.fromPlainObject);
                return response.data;
            }
        );
    }

    public cgetSupplierExternalCustomerMapping(
        params: URLSearchParams = new URLSearchParams(),
        accountId: string
    ): Promise<ApiResult<PaginatedResponse<Supplier>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/suppliers/${accountId}/external-customer-mappings/search`, { params }),
            response => {
                response.data.items = response.data.items.map(Supplier.fromPlainObject);
                return response.data;
            }
        );
    }

    public cgetCustomerExternalCustomerMapping(
        params: URLSearchParams = new URLSearchParams(),
        accountId: string
    ): Promise<ApiResult<PaginatedResponse<Supplier>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/customers/${accountId}/external-customer-mappings/search`, { params }),
            response => {
                response.data.items = response.data.items.map(Supplier.fromPlainObject);
                return response.data;
            }
        );
    }
}
